import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  time: number;
  onDone?: () => void;
}

export default function ProgressBar({ time, onDone }: ProgressBarProps) {
  return (
    <div className={styles['progress-bar']}>
      <div
        className={styles['progress']}
        style={{
          animationDuration: `${time}ms`,
        }}
        onAnimationEnd={onDone}
      ></div>
    </div>
  );
}
